module.exports = __webpack_public_path__ + "img/autohuh-original-480.4f6f515a.webp";